import { render, staticRenderFns } from "./ProvincesProducts.vue?vue&type=template&id=da1fb6c6&scoped=true"
import script from "./ProvincesProducts.vue?vue&type=script&lang=js"
export * from "./ProvincesProducts.vue?vue&type=script&lang=js"
import style0 from "./ProvincesProducts.vue?vue&type=style&index=0&id=da1fb6c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1fb6c6",
  null
  
)

export default component.exports